package com.advaita.cloud.drive.shared

import kotlinx.serialization.Serializable

/**
 * Production presigned-upload DTOs — see spec §4.
 * Every upload goes through the multipart lifecycle (start → sign → confirm →
 * complete) regardless of size; a small file is simply a 1-part upload.
 */

@Serializable
data class UploadStartRequest(
    /** The caller's own destination path. Null (with no [parentId]) means the caller's root. */
    val parentPath: String? = null,
    val name: String,
    val mimeType: String? = null,
    val size: Long,
    val relativePath: String? = null,
    /**
     * ADV-1329: the id of a destination folder the caller need not own — a shared folder. The
     * upload then belongs to the folder's owner. Mutually exclusive with [parentPath].
     */
    val parentId: String? = null,
)

@Serializable
data class UploadStartMultipartResponse(
    val sessionId: String,
    val partSize: Long,
    val totalParts: Int,
)

@Serializable
data class UploadPartUrlResponse(
    val url: String,
    val method: String,
    val headers: Map<String, String>,
)

@Serializable
data class UploadConfirmPartRequest(
    val etag: String,
    val sizeBytes: Long,
)

@Serializable
data class UploadStatusResponse(
    val status: UploadSessionStatus,
    val partsTotal: Int,
    val partsUploaded: Int,
    val partsRemaining: List<Int>,
)

@Serializable
data class ResumeKeyResponse(
    val keyBase64: String,
)
